<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item>
          <v-list-item-title>เพิ่มการระบุสถานที่</v-list-item-title>
        </v-list-item>
      </v-toolbar>
      <div class="pt-2 px-4" style="height: 100%; overflow: auto">
        <div>
          <v-text-field
            v-model="search"
            class="fix-google-chrome"
            prepend-inner-icon="mdi-magnify"
            outlined
            dense
            clearable
            hide-details
          >
          </v-text-field>

          <div class="mt-2 mb-4">
            <button type="button" @click="$emit('onClickAddLocation')">
              <v-icon left small color="primary">mdi-plus</v-icon>
              <span class="caption primary--text"> เพิ่มสถานที่ใหม่ </span>
            </button>
          </div>
        </div>

        <RecycleScroller
          :items="filterOffSideLocations"
          :item-size="74"
          key-field="client_site_location_uuid"
          v-slot="{ item }"
        >
          <v-card color="#f5f5f5" outlined class="d-flex align-center mb-2">
            <span class="pa-4">
              <input
                :id="item.client_site_location_uuid"
                :value="item.client_site_location_uuid"
                v-model="offSideLocationsSelected"
                style="width: 18px; height: 18px"
                type="radio"
              />
            </span>
            <v-list-item two-line class="px-0">
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.title_th }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  ละติจูด: {{ item.latitude }}, ลองจิจูด: {{ item.longitude }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-card>
        </RecycleScroller>
        <div v-if="isLoading">
          <v-card
            color="#f5f5f5"
            v-for="num in 2"
            :key="num"
            outlined
            class="mb-2 px-4 py-2"
          >
            <Skeleton width="200px" />
            <Skeleton :count="1" />
          </v-card>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center">
          <v-btn
            class="primary mr-3"
            :disabled="!isTimeAttendanceOffSiteLocationAddDataChange"
            depressed
            @click="onSubmit"
          >
            เพิ่มการระบุสถานที่
          </v-btn>
          <v-btn depressed @click="handleCancel"> ยกเลิก </v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <v-dialog v-model="dialogRadiusMeter" persistent max-width="500">
      <v-form ref="formRadiusMeter" lazy-validation>
        <v-card>
          <v-card-title>
            <span>โปรดระบุรัศมี (เมตร)</span>
          </v-card-title>
          <v-card-text>
            <label class="body-2">
              รัศมี (เมตร)
              <span class="red--text"><strong>*</strong></span>
            </label>
            <v-text-field
              class="fix-google-chrome mt-1"
              v-model="radius"
              :rules="[
                (v) => !!v || 'โปรดระบุรัศมี (เมตร)',
                (v) => /^[0-9]*$/.test(v) || 'รัศมีต้องเป็นตัวเลขจำนวนเต็ม',
              ]"
              clearable
              required
              outlined
              dense
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="handleDialogRadiusMeterCancel"> ยกเลิก </v-btn>
            <v-btn color="primary" text @click="handleDialogRadiusMeterSubmit">
              ตกลง
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
  </v-navigation-drawer>
</template>

<script>
import moment from 'moment'
import { Skeleton } from 'vue-loading-skeleton'
import { RecycleScroller } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'

import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    RecycleScroller,
    Skeleton,
    ConfirmDialog,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    timeAttendanceOffSiteGrant: {
      type: Object,
    },
    timeAttendanceOffSiteGrantInit: {
      type: Object,
    },
  },
  watch: {
    formShow(value) {
      if (value) {
        this.getOffSideLocations()
      }
    },
  },
  data() {
    return {
      radius: null,
      dialogRadiusMeter: false,
      isLoading: false,
      offSideLocationsSelected: [],
      search: '',
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    isTimeAttendanceOffSiteLocationAddDataChange() {
      if (this.offSideLocationsSelected.length) {
        this.$emit('isTimeAttendanceOffSiteLocationAddDataChange', true)
        return true
      }
      this.$emit('isTimeAttendanceOffSiteLocationAddDataChange', false)
      return false
    },
    offSideLocations() {
      return this.$store.state.offSiteLocation.offSiteLocations
    },
    filterOffSideLocations() {
      const items = this.offSideLocations
      return items.filter((item) => {
        if (item.title_en) {
          return (
            item.title_en.toLowerCase().includes(this.search.toLowerCase()) ||
            item.title_th.toLowerCase().includes(this.search.toLowerCase())
          )
        }
        return item.title_th.toLowerCase().includes(this.search.toLowerCase())
      })
    },
  },
  methods: {
    ...mapActions({
      fetchOffSiteLocations: 'offSiteLocation/fetchOffSiteLocations',
      editTimeAttendanceOffSiteGrant:
        'timeAttendanceOffSiteGrant/editTimeAttendanceOffSiteGrant',
    }),
    handleDialogRadiusMeterCancel() {
      this.dialogRadiusMeter = false
      this.radius = null
      this.$refs.formRadiusMeter.resetValidation()
    },
    async handleDialogRadiusMeterSubmit() {
      if (this.$refs.formRadiusMeter.validate()) {
        try {
          this.dialogRadiusMeter = false
          this.$store.state.loading = true

          const { company_uuid } = this.$store.state.authentication.company

          const payload = {
            company_uuid,
            time_attendance_offsite_grant_uuid:
              this.timeAttendanceOffSiteGrant
                .time_attendance_offsite_grant_uuid,
            data: {
              employee_uuid:
                this.timeAttendanceOffSiteGrant.employeeSelected.value,
              start_time:
                this.timeAttendanceOffSiteGrant.date_start &&
                this.timeAttendanceOffSiteGrant.time_start
                  ? moment
                      .utc(
                        `${this.timeAttendanceOffSiteGrant.date_start} ${this.timeAttendanceOffSiteGrant.time_start}`
                      )
                      .format()
                  : null,
              end_time:
                this.timeAttendanceOffSiteGrant.date_end &&
                this.timeAttendanceOffSiteGrant.time_end
                  ? moment
                      .utc(
                        `${this.timeAttendanceOffSiteGrant.date_end} ${this.timeAttendanceOffSiteGrant.time_end}`
                      )
                      .format()
                  : null,
              locations: [
                ...this.timeAttendanceOffSiteGrant.locations.map((item) => ({
                  client_site_location_uuid:
                    item.offsite_location.client_site_location_uuid,
                  radius_meter: item.radius_meter,
                })),
                {
                  client_site_location_uuid: this.offSideLocationsSelected,
                  radius_meter: parseInt(this.radius),
                },
              ],
            },
          }

          const timeAttendanceOffSiteGrantUpdated =
            await this.editTimeAttendanceOffSiteGrant(payload)
          this.radius = null
          this.$refs.formRadiusMeter.resetValidation()
          this.offSideLocationsSelected = []
          this.$emit(
            'addTimeAttendanceOffSiteLocationAddSuccess',
            timeAttendanceOffSiteGrantUpdated
          )
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'success',
            timeout: 2000,
            message: 'เพิ่มข้อมูลสำเร็จ',
          }

          this.$store.commit('SET_SNACKBAR', snackbar)
        } catch (error) {
          this.$store.state.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }
      }
    },
    async getOffSideLocations() {
      try {
        const { company_uuid } = this.$store.state.authentication.company

        this.isLoading = true

        const payload = {
          company_uuid,
          params: {
            dpc: 'time-attendance-off-site-grant-to-list-time-attendance-off-site-location',
          },
        }
        await this.fetchOffSiteLocations(payload)
        this.isLoading = false
      } catch (error) {
        this.isLoading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    onSubmit() {
      this.dialogRadiusMeter = true
    },
    handleCancel() {
      this.employeesSelected = []
      this.$emit('onClickBlack')
    },
    handleBack() {
      if (this.isTimeAttendanceOffSiteLocationAddDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$emit('onClickBlack')
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
      this.$emit('onClickBlack')
    },
  },
}
</script>
